import BankingFAQs from './BankingFAQs';

export default BankingFAQs;
